/**
 * One audible Task 2 ending per attempt.
 *
 * Competing sources of the same clip (`task2-end.mp3` / "C'est la fin de la tâche 2"):
 * - VoiceAgent handleTool_endTask → playLocalAudio
 * - TaskTwo handleFinishTaskClick / timer → playStaticAudioUrl
 *
 * Claim immediately, before any await, so a concurrent tool/CTA cannot start a
 * second playback. Reset on a new Task 2 page instance only.
 */

export type Task2EndingSource = 'idle' | 'cta' | 'tool' | 'timer' | 'onTaskCompleted';

let claimedBy: Task2EndingSource = 'idle';
let ctaInvocations = 0;

export function resetTask2EndingAuthority(): void {
  claimedBy = 'idle';
  ctaInvocations = 0;
}

export function claimTask2Ending(source: Exclude<Task2EndingSource, 'idle'>): boolean {
  if (source === 'cta') ctaInvocations += 1;
  if (claimedBy !== 'idle') {
    return false;
  }
  claimedBy = source;
  return true;
}

export function isTask2EndingClaimed(): boolean {
  return claimedBy !== 'idle';
}

export function getTask2EndingClaimant(): Task2EndingSource {
  return claimedBy;
}

export function getTask2EndingCtaInvocations(): number {
  return ctaInvocations;
}

export function logTask2Ending(event: string, extra?: Record<string, unknown>): void {
  console.log('[TASK2-END]', {
    t: Date.now(),
    event,
    claimant: claimedBy,
    ctaInvocations,
    ...extra,
  });
}
